export default __webpack_public_path__ + "static/127-0e6c5cb37307fd66ea0ee1578ede2b6a.gif";